<template>
		<div class="home-page tool-page">
		<Header></Header>
      <div class="mission-content tool-page-content ac crfff">
        <div class="tool-back" @click="back">
          <img src="../../static/images/back.png" />
        </div>
        <div class="fs50 tool-page-title">{{$t('GenerateImage')}}</div>
        <div class="css-1asaykn tool-page-panel">
          <div class="css-12nj5ib">
            <div style="">{{$t('generateTips1')}}<br /><br />{{$t('generateTips2')}}</div>
            <h6 class="css-po8uek wen-c mt50 ac">
                <strong class="fs40">{{$t('Prompt')}}</strong>
                <div class="mt30" style="line-height: 1rem;font-size: 0.8rem">
                  {{$t('PromptTips1')}}<br />
                  {{$t('PromptTips2')}}<br />
                  {{$t('PromptTips3')}}
                </div>
              </h6>
          </div>
          <form class="auth-form mt30 css-6y7yrh">
            <div class="" v-if="isShow=='bur'">
              <div class="">
                <div class="quan table mt50 disflex">
                  <span class="tab" :class="{'active':isMain==key}" @click="getMain(key)" v-for="(item,key,index) in options.main">{{item}}</span>
                </div>
                <div class="table table-cate mt30 disflex">
                  <span class="tab" @click="getCate(key)" :class="{'active':isCate==key}" v-if="isMain" v-for="(item,key,index) in options.cate[isMain]">{{item}}</span>
                </div>
                <div class="tab-content" v-for="(item,index) in options.choices[isCate]">
                    <span class="tab-c" @click="getArr(key1,item,index)" :class="{'active':ids.indexOf(key1) != -1}" v-for="(item1,key1,index1) in item.value">
                      <span class="title">{{item1}}</span>
                    </span>
                </div>
              </div>
            </div>
            <div class="" v-else>
              <div class="css-1gzwcwv">
                <div class="custom-input">
                  <textarea :placeholder="$t('generateImageTips1')" v-model="description"></textarea>
                </div>
              </div>
              <div class="css-1gzwcwv">
                <div class="custom-input">
                  <input
                    type="text"
                    :placeholder="$t('generatePromptsTips1')"
                    v-model="negativePrompt"
                  />
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="tool-generate">
          <button @click="creatImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
      <div class="tool-credit-row">
        <button class="btn btn-blue">{{ $t('ChancesLeft') }}: {{ score }}</button>
        <button class="btn" @click="goPurchaseChances">
          <strong>{{ $t('BuyChances') }}</strong>
          <img src="../../static/images/buy.png"></button>
      </div>
      <Dialog class="result-image-dialog" ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 50rem">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 2rem;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:1rem;margin-bottom: 1rem;">{{ shouldCopyMediaLink() ? $t('downTips1') : $t('downloadImageTips') }}</div>
                <div style="margin-bottom: 1.5rem;">{{detail.title}}</div>
               <img :src="detail.url" style="width:80%;" />
                <div class="img-tools" v-if="shouldCopyMediaLink()">
                  <div class="ac mt20">
                    <div class="input-item mt50" style="margin-bottom: 1.5rem;width: 80%">
                      <div class="input-item2">
                        <input class="input" :value="getDownloadUrl()" disabled  placeholder="">
                      </div>
                    </div>
                    <button class="button fw7" style="width: 100%;font-size: 1rem" id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy"  v-if="detail.url">{{$t('copyLink')}}<img style="width: 1.2rem" src="../../static/images/copy1.png" /></button>
                  </div>
                </div>
                <div class="ac mt30" v-else>
                  <button class="button fw7" style="width: 100%;font-size: 1rem" @click="downloadImage">{{$t('downloadImage')}}</button>
                </div>
              </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
import { saveMedia, shouldCopyMediaLink } from '../utils/mediaDownload'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        invited_code:'',
        invitedAlert:'',
        imageShow:false,
        detail:{},
        description:'',
        negativePrompt:'',
        score:'',
        isShow:'en',
        options:{
          main: {},
          cate: {},
          choices: {}
        },
        isMain:'Living_Organism',
        isCate:'Human',
        ids:[],
        numIds:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      }
    },
	watch: {

	},
	computed:{
	},
  mounted() {
    let that = this;
  },
  created(){
    this.getHome();
    // this.getOptions();
    if(localStorage.getItem('lang')){
      this.isShow = 'en'
    }
  },
  methods: {
    shouldCopyMediaLink,
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getArr(key,item2,index){
      console.log(index)
      console.log(this.numIds[index])
      if(this.ids.indexOf(key) == -1){
        if(item2.single=='yes'){
          if(this.ids.indexOf(this.numIds[index][0]) !== -1){
            this.ids = this.ids.filter(item => item !== this.numIds[index][0]);
          }
          this.numIds[index].splice(-1, 1);
          if(this.numIds[index].length>=1){
            return;
          }
          this.numIds[index].push(key)
        }
        this.ids.push(key)
      }else{
        this.ids = this.ids.filter(item => item !== key);
        this.numIds[index] = this.numIds[index].filter(item => item !== key);
      }
    },
    getCate(key){
      this.ids = []
      this.numIds = [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      this.isCate = key
    },
    getMain(key){
      this.isMain = key
      this.ids = []
      this.numIds = [[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]]
      if(key=='Non_living_Entity'){
        this.isCate = 'Architecture'
      }else{
        this.isCate = 'Human'
      }

    },
		back(){
      this.$router.go(-1);
		},
    getOptions(){
      let that =this;
      that.$api.get('/api/index/get_mm_tags',null,r =>{
      	that.$parent.returnCode(r,function(){
          that.options=r.data
        });
      })
    },
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
    creatImage() {
      var that = this;
      let data = {}
      if(that.isShow=='bur'){
        console.log(that.ids)
          data = {
            ids:that.ids
          }
      }else{
        data = {
          description:that.description,
          negativePrompt:that.negativePrompt
        }
        if (!that.description) {
          that.$utils.alertText(that.$t('generateImageTips1'),50);
          return;
        }
        console.log(that.negativePrompt)
        if (!that.negativePrompt) {
          that.$utils.alertText(that.$t('generatePromptsTips1'),50);
          return;
        }
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/art_image',data,r =>{
        if(r.code==0){
          that.description = ''
          that.negativePrompt = ''
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,50);
          return;
        }
        that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.$refs.imgDialog.showMaskFun();
            that.getHome();
            that.imageShow = true
            that.description = ''
            that.negativePrompt = ''
            that.detail = r.data
          });
        })
    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    getDownloadUrl(){
      return this.detail.download_url || this.detail.url
    },
    downloadImage(){
      const downloadUrl = this.getDownloadUrl()
      saveMedia(downloadUrl)
    },
    isAndroidWebView(){
      const ua = navigator.userAgent || '';
      if (!/Android/i.test(ua)) return false;

      const hasWebViewMarkers = (
        /\bwv\b/.test(ua) ||
        /; wv\)/.test(ua) ||
        /WebView/.test(ua) ||
        /XWEB_/.test(ua)
      );
      const isNormalBrowser = (
        /Chrome\/[.0-9]+ Mobile Safari\/[.0-9]+/.test(ua) &&
        !/; wv\)/.test(ua)
      );
      const isTrustedBrowser = /VivoBrowser|MiuiBrowser|HuaweiBrowser/i.test(ua);

      return !isNormalBrowser && !isTrustedBrowser && (hasWebViewMarkers || !/Chrome\//.test(ua));
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    },
	}
}
</script>
<style>
  .table-cate{flex-wrap: wrap;border: none;}
  .table-cate span{border:4px solid #ff7b9f;margin: 0 10px 20px;width: calc(50% - 20px);border-radius: 10px !important;padding:15px 10px}
  .tab-content{flex-wrap: wrap;margin: 20px 0 0;text-align: left;border-top: 4px solid #fff;padding-top: 20px;}
  .tab-c{background: #001586;margin: 10px;color: #ffffff;padding:5px 10px;display: inline-block;border: 1px solid #fff;}
  .tab-c.active{background: #f17599;}
</style>



// WEBPACK FOOTER //
// src/page/generateImage.vue